<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import {
  RangeCalendarCellTrigger,
  type RangeCalendarCellTriggerProps,
  useForwardProps,
} from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';

const props = defineProps<RangeCalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarCellTrigger
    :class="
      cn(
        buttonVariants({ variant: 'ghost' }),
        'tw-h-8 tw-w-8 tw-p-0 tw-font-normal data-[selected]:tw-opacity-100',
        '[&[data-today]:not([data-selected])]:tw-bg-secondary-100 [&[data-today]:not([data-selected])]:tw-text-secondary-900 dark:[&[data-today]:not([data-selected])]:tw-bg-secondary-800 dark:[&[data-today]:not([data-selected])]:tw-text-secondary-50',
        // Selection Start
        'data-[selection-start]:tw-bg-secondary-500 data-[selection-start]:tw-text-surface-0 data-[selection-start]:hover:tw-bg-secondary-700 data-[selection-start]:hover:tw-text-surface-0 data-[selection-start]:focus:tw-bg-secondary-700 data-[selection-start]:focus:tw-text-surface-0 dark:data-[selection-start]:tw-bg-secondary-500 dark:data-[selection-start]:tw-text-surface-0 dark:data-[selection-start]:hover:tw-bg-secondary-500 dark:data-[selection-start]:hover:tw-text-surface-0 dark:data-[selection-start]:focus:tw-bg-secondary-500 dark:data-[selection-start]:focus:tw-text-surface-0',
        // Selection End
        'data-[selection-end]:tw-bg-secondary-500 data-[selection-end]:tw-text-surface-0 data-[selection-end]:hover:tw-bg-secondary-700 data-[selection-end]:hover:tw-text-surface-0 data-[selection-end]:focus:tw-bg-secondary-700 data-[selection-end]:focus:tw-text-surface-0 dark:data-[selection-end]:tw-bg-secondary-500 dark:data-[selection-end]:tw-text-surface-0 dark:data-[selection-end]:hover:tw-bg-secondary-500 dark:data-[selection-end]:hover:tw-text-surface-0 dark:data-[selection-end]:focus:tw-bg-secondary-500 dark:data-[selection-end]:focus:tw-text-surface-0',
        // Outside months
        'data-[outside-view]:tw-text-secondary-500 data-[outside-view]:tw-opacity-50 [&[data-outside-view][data-selected]]:tw-text-secondary-600 [&[data-outside-view][data-selected]]:tw-opacity-60 dark:data-[outside-view]:tw-text-secondary-400 dark:[&[data-outside-view][data-selected]]:tw-text-secondary-300 dark:[&[data-outside-view][data-selected]]:tw-text-60',
        // Disabled
        'data-[disabled]:tw-text-secondary-500 data-[disabled]:tw-opacity-50 dark:data-[disabled]:tw-text-secondary-400',
        // Unavailable
        'data-[unavailable]:tw-text-secondary-50 data-[unavailable]:tw-line-through dark:data-[unavailable]:tw-text-secondary-50',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCellTrigger>
</template>
